{
  "profile.title": "Exognitos benim hakkımda ne biliyor?",
  "profile.lede": "Planlamayı ve asistan bağlamını etkileyebilen kalıcı bilgileri gözden geçir. Her kayıt izlenebilir, düzeltilebilir, hariç tutulabilir ve kaldırılabilir kalır.",
  "profile.error.generic": "Bu profil değişikliği tamamlanamadı. Yeniden dene.",
  "profile.value.none": "Kaydedilmedi",
  "profile.action.export": "Profili dışa aktar",
  "profile.action.add": "Bilgi ekle",
  "profile.action.verify": "Doğrula",
  "profile.action.dispute": "Tartışmalı işaretle",
  "profile.action.archive": "Arşivle",
  "profile.action.restore": "Geri yükle",
  "profile.action.deletePermanently": "Kalıcı olarak sil",
  "profile.action.cancel": "Vazgeç",
  "profile.action.save": "Bilgiyi kaydet",
  "profile.filter.category": "Kategori",
  "profile.filter.allCategories": "Tüm kategoriler",
  "profile.filter.includeSensitive": "Hassas bilgileri göster",
  "profile.filter.includeSensitiveDescription": "Hassas değerler, sen açıkça gösterene kadar gizli kalır.",
  "profile.filter.includeArchived": "Arşivlenmiş bilgileri göster",
  "profile.filter.includeArchivedDescription": "Arşivlenen bilgiler gelecekteki bağlamdan çıkarılır.",
  "profile.stale.title": "Gözden geçirilmeli",
  "profile.stale.description": "Gözden geçirme tarihi geçen veya doğrulaması dikkat gerektiren bilgiler.",
  "profile.stale.empty": "Şu anda gözden geçirilmesi gereken bir şey yok.",
  "profile.stale.badge": "İnceleme zamanı",
  "profile.facts.title": "Profil bilgileri",
  "profile.facts.description": "Hesap saat dilimi, dili ve görünen adı hesap ayarlarında tek doğru kaynak olarak kalır; bu liste destekleyici kişisel bağlamı tutar.",
  "profile.empty.title": "Henüz profil bilgisi yok",
  "profile.empty.description": "Yalnızca Exognitos'un ve yetkilendirdiğin asistanların kullanmasını istediğin bağlamı ekle.",
  "profile.meta": "{{source}} · {{updated}} tarihinde güncellendi · revizyon {{revision}}",
  "profile.delete.title": "“{{title}}” kalıcı olarak silinsin mi?",
  "profile.delete.description": "Bu işlem bilgiyi ve asistan bağlamındaki devamlılığını kaldırır. Bağımsız görevler, notlar ve diğer kayıtlar silinmez.",
  "profile.form.createTitle": "Profil bilgisi ekle",
  "profile.form.editTitle": "Profil bilgisini düzenle",
  "profile.form.description": "Her bilginin hassas biçimde gözden geçirilebilmesi ve geri çekilebilmesi için tek kalıcı iddia tut.",
  "profile.form.category": "Kategori",
  "profile.form.key": "Kalıcı anahtar",
  "profile.form.keyHint": "Küçük harf, sayı, nokta, tire veya alt çizgi kullan; örneğin communication.response_style.",
  "profile.form.title": "Anlaşılır başlık",
  "profile.form.value": "Değer",
  "profile.form.sensitivity": "Hassasiyet",
  "profile.form.assistantConsent": "Yetkili asistan bağlamında kullanılmasına izin ver",
  "profile.form.assistantConsentDescription": "Asistan yine de ilgili alan kapsamına ihtiyaç duyar; izni geri çekmek bu değeri yeni bağlam paketlerinden çıkarır.",
  "profile.form.consentPurpose": "Asistan bunu neden kullanabilir?",
  "profile.form.required": "Anahtar, başlık ve değer gir.",
  "profile.form.consentPurposeRequired": "Asistan erişimine izin vermeden önce kullanım amacını açıkla.",
  "profile.form.loadingFact": "En güncel revizyon hâlâ yükleniyor. Birazdan yeniden kaydet.",
  "profile.history.title": "Revizyon geçmişi",
  "profile.history.empty": "Daha eski bir revizyon kaydedilmedi.",
  "profile.history.item": "{{action}} · revizyon {{revision}} · {{date}}",
  "profile.category.communication": "İletişim",
  "profile.category.values_goals": "Değerler ve hedefler",
  "profile.category.constraints": "Kısıtlar ve uygunluk",
  "profile.category.people_roles": "Kişiler ve roller",
  "profile.category.environment": "Ortam ve araçlar",
  "profile.category.accessibility": "Erişilebilirlik",
  "profile.category.wellbeing": "İyi oluş",
  "profile.category.health": "Sağlık",
  "profile.category.financial": "Finansal",
  "profile.sensitivity.normal": "Olağan",
  "profile.sensitivity.private": "Özel",
  "profile.sensitivity.sensitive": "Hassas",
  "profile.verification.unverified": "Doğrulanmadı",
  "profile.verification.verified": "Doğrulandı",
  "profile.verification.disputed": "Tartışmalı",
  "profile.source.user_authored": "Sen ekledin",
  "profile.source.assistant_proposed": "Bir asistan önerdi",
  "profile.source.imported": "İçe aktarıldı",
  "profile.source.system_reference": "Hesap referansı"
}
